<template>
  <ModalDialog
    ref="dialog"
    title="Setup Customer Price List"
    submitTitle="Continue"
    :submitDisabled="!hasIntegrationTypeSelected"
    icon="fa-tag"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" loadingText="Loading pricing details..." />
    <div v-if="!loading && !loadingError">
      <h3>Pending Price Updates Exist</h3>
      A sales price request exists in the system that is currently pending approval / pending schedule.<br />
      Select below how the new customer price list will integrate with the pending price request<br />
      <br /><br />
      <div class="ml-4">
        <FormOptionGroup field="priceListIntegrationType">        
          <FormOption label="Add to pending request (default)" name="priceListIntegrationType" :setting="PriceListIntegrationTypes.includePending" v-model="priceListIntegrationType" inline="false" /><br />
          <div class="ml-4">
            Uses the pending sales price request as the source for the customer price lists and inserts the price list into the same pending price request.<br />
            <strong>Warning:</strong><br />
            <ul>
              <li>The new customer price list will not be active until the entire pending price request is live</li>
              <li>For new customers, this means the customer will not have an active price list immediately and will default to a single sales rate setting for all prices</li>
            </ul>
          </div>
          <FormHorizontalRule />
          <FormOption label="Use live sales prices" name="priceListIntegrationType" :setting="PriceListIntegrationTypes.seperatePriceRequest" v-model="priceListIntegrationType" inline="false" /><br />
          <div class="ml-4">
            Ignores the pending sales price request, and uses the currently live sales prices as the source for the customer price lists.<br />
            Creates the customer price list into a new price request that can be approved immediately.<br />
            <strong>Warning:</strong><br />
            <ul>
              <li>When the pending sales request goes live, this new customer price list will be automatically changed to reflect any updated sales prices without notice to the customer</li>
              <li>Any price variations in the price list will not be changed</li>
            </ul>
          </div>
          <FormHorizontalRule />
          <FormOption label="Use pending sales prices" name="priceListIntegrationType" :setting="PriceListIntegrationTypes.seperatePriceRequestLinkSource" v-model="priceListIntegrationType" inline="false" /><br />
          <div class="ml-4">
            Uses the pending sales price request as the source for the customer price lists, but creates a seperate price request for the customer price list.<br />
            All pending sales prices will be active for the new customer price list.<br />
            <strong>Warning:</strong><br />
            <ul>
              <li>The new customer price list will be in a seperate price request that can be approved before the pending sales price</li>
              <li>This will result in the customer price list containing sales price updates that may still be pending approval or schedule and may not be active for other customers</li>
              <li>If the pending sales price updates are denied, the customer price list will automatically reset back to live sales prices without notice to the customer</li>
            </ul>        
          </div>        
        </FormOptionGroup>
      </div>
    </div>
    
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { PriceRequestTypes, PricingRequestStatusTypes, PriceListIntegrationTypes } from '@/store/types'

export default {
  name: "CustomerPriceListSetupDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    
  },
  data() {
    return {
      dialogForm: {},
      loading: true,
      loadingError: '',
      priceListIntegrationType: ''
    }
  },
  mounted() {
  },
  created() {
    this.PriceListIntegrationTypes = PriceListIntegrationTypes
  },
  computed: {
    hasIntegrationTypeSelected() {
      return this.priceListIntegrationType != ''
    }
  },
  methods: {
    show() {
      // Reset form
      this.dialogForm = { }
      this.loading = true
      this.loadingError = ''

      // Figure out if a pending sales price request exists. If not, just run default mode of seperate price request
      this.$nextTick(() => {
        this.loadPriceData()
      })

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    loadPriceData() {
      this.$apiService.pricingService.getPriceRequestList({
        type: PriceRequestTypes.sales,
        status: [
          PricingRequestStatusTypes.draft,
          PricingRequestStatusTypes.pendingApproval,
          PricingRequestStatusTypes.pendingSchedule
        ]
      }).then(response => {

        // If no pending price requests available, just run default mode & have a seperate price request for the price list
        if(response.data.length == 0) {
          this.modalClosed(PriceListIntegrationTypes.seperatePriceRequest)
          this.hide()
        }
      })
      .catch(err => {
        this.loadingError = 'Error accessing price request list'
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
    },
    onSubmitted() {
      this.modalClosed(this.priceListIntegrationType)
      this.hide()
    },
    onClosed() {
      this.modalClosed(null)
    }
  }
}
</script>